<template>
    <v-dialog
      v-model="dialog"
      :max-width="options.width"
    >
      <v-card>
        <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text"> {{ title }}</v-toolbar-title>
      </v-toolbar>
        <v-card-text>
			<br>
			{{message}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog=false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    message: null,
    title: null,
    options: {
      color: 'primary',
      width: 290,
      zIndex: 200
    }
  }),
  methods: {
    open(title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
    },
  },
}
</script>